"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RFPVendorResponseQuery = exports.RFPVendorResponseWaysteUpdate = exports.RFPVendorResponseUpdate = exports.RFPVendorResponseCreate = exports.RFPVendorResponseWayste = exports.RFPVendorResponseTransport = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
const meta_data_1 = require("../common/meta-data");
const rfp_common_types_1 = require("./rfp-common-types");
const rfp_sku_1 = require("./rfp-sku");
// Create a basic version of RFPTransport to avoid circular dependency
const RFPTransportBase = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    familyID: typebox_1.Type.String({ format: 'uuid' }),
    noteToVendor: typebox_1.Type.Optional(typebox_1.Type.String()),
    proposalNumber: typebox_1.Type.Integer(),
    status: rfp_common_types_1.RFPStatus,
    serviceLocation: typebox_1.Type.Any(), // Using Type.Any() to avoid circular dependency
    businessType: typebox_1.Type.Optional(typebox_1.Type.String()),
    targetProposalAmount: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    deadlineDate: typebox_1.Type.String({ format: 'date-time' }),
    currentVendor: typebox_1.Type.Optional(typebox_1.Type.String()),
    forLeadID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    forCustomerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    forVendorID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    serviceStartDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    voidDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    awardDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    rfpName: typebox_1.Type.Optional(typebox_1.Type.String()),
});
// Create a basic version of RFPTransportWayste to avoid circular dependency
const RFPTransportWaysteBase = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    noteToVendor: typebox_1.Type.Optional(typebox_1.Type.String()),
    proposalNumber: typebox_1.Type.Integer(),
    serviceLocation: typebox_1.Type.Any(), // Using Type.Any() to avoid circular dependency
    businessType: typebox_1.Type.Optional(typebox_1.Type.String()),
    targetProposalAmount: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    deadlineDate: typebox_1.Type.String({ format: 'date-time' }),
    serviceStartDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    voidDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    awardDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    metadata: meta_data_1.MetaData,
});
exports.RFPVendorResponseTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    rfpID: typebox_1.Type.String({ format: 'uuid' }),
    vendorID: typebox_1.Type.String({ format: 'uuid' }),
    vendorName: typebox_1.Type.String(),
    status: rfp_common_types_1.RFPStatus,
    accessLink: typebox_1.Type.String(),
    rfpSkus: typebox_1.Type.Array(rfp_sku_1.RFPSkuTransport),
    /**
     * Should be the same as the RFP deadlineDate
     */
    accessLinkExpirationDate: typebox_1.Type.String({ format: 'date-time' }),
    voidMessage: typebox_1.Type.Optional(typebox_1.Type.String()),
    awardMessage: typebox_1.Type.Optional(typebox_1.Type.String()),
    lostMessage: typebox_1.Type.Optional(typebox_1.Type.String()),
    declinedMessage: typebox_1.Type.Optional(typebox_1.Type.String()),
    noteToVendor: typebox_1.Type.Optional(typebox_1.Type.String()),
    noteFromVendor: typebox_1.Type.Optional(typebox_1.Type.String()),
    awardDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date-time' })),
    metadata: meta_data_1.MetaData,
});
exports.RFPVendorResponseWayste = typebox_1.Type.Intersect([
    exports.RFPVendorResponseTransport,
    typebox_1.Type.Object({
        rfp: RFPTransportWaysteBase,
    }),
]);
exports.RFPVendorResponseCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RFPVendorResponseTransport, ['id', 'metadata', 'awardDate', 'accessLink', 'rfpSkus']),
    typebox_1.Type.Object({
        rfp: typebox_1.Type.Optional(RFPTransportBase),
        rfpSkus: typebox_1.Type.Array(typebox_1.Type.Intersect([typebox_1.Type.Omit(rfp_sku_1.RFPSkuCreate, ['rfpID'])])),
    }),
]);
exports.RFPVendorResponseUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RFPVendorResponseCreate, ['rfpID']),
    typebox_1.Type.Object({
        awardDate: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'date-time' })),
    }),
]));
exports.RFPVendorResponseWaysteUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.RFPVendorResponseWayste, [
        'vendorName',
        'accessLink',
        'voidMessage',
        'awardMessage',
        'lostMessage',
        'noteToVendor',
        'awardDate',
        'metadata',
        'rfpSkus',
        'rfpID',
        'vendorID',
    ]),
    typebox_1.Type.Object({
        rfpSkus: typebox_1.Type.Optional(typebox_1.Type.Array(rfp_sku_1.RFPSkuUpdate)),
    }),
]));
exports.RFPVendorResponseQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    limit: typebox_1.Type.Integer(),
    offset: typebox_1.Type.Integer(),
    orderBy: typebox_1.Type.Optional(typebox_1.Type.Union([typebox_1.Type.Literal('createdAt'), typebox_1.Type.Literal('lastUpdatedAt')])),
    reverseSort: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    vendorID: typebox_1.Type.String({ format: 'uuid' }),
    rfpID: typebox_1.Type.String({ format: 'uuid' }),
    /**
     * Either pass an array of actual VendorResponse OR true for things with a status OR false with things with no status
     * Needs to be a comma separated list of type VendorResponse. Use [].join(',')
     */
    status: typebox_1.Type.Union([typebox_1.Type.Boolean(), typebox_1.Type.String({ minLength: 1 })]),
    createdBefore: typebox_1.Type.String({ format: 'date-time' }),
    createdAfter: typebox_1.Type.String({ format: 'date-time' }),
    awardDate: typebox_1.Type.String({ format: 'date-time' }),
}));
//# sourceMappingURL=rfp-vendor-response.js.map